import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("C:/Users/BenjaminGrand/Documents/live-display/public/layouts/default.vue").then(m => m.default || m))
}